export const TYPE = {
    Primary: 'primary',
    Secondary: 'secondary',
};
export const ORIENTATION = {
    Horizontal: 'horizontal',
    Vertical: 'vertical',
};
export const MARKER_POSITION = {
    Before: 'before',
    After: 'after',
};
